import React, {useEffect, useState} from "react";
import axios from "axios";

export default function BrandAssetsCategory() {
  const [totalCount, setTotalCount] = useState(0);
  const [list, setList] = useState([]);

  const [data, setData] = useState({
    categoryCode: '',
    categoryName: '',
    activeStatus: 'Y',
    sortOrder: 0,
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value
    });
  };

  async function getList() {
    axios({
      method: 'get',
      url: 'https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/getAssetCategoryList.php?sortColumn=categoryName&sortOrder=desc'
    }).then(function (response) {
      setList(response.data.list);
      setTotalCount(response.data.totalCnt);
    });
  }

  useEffect(() => {
    getList();
  }, []);

  const handleChange = (id: any, status: string) => {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/updActiveStatus.php", {
      ID: id,
      activeStatus: status === 'Y' ? 'N' : 'Y',
    }).then(function (response) {
      if (response?.data?.result) {
        alert(response?.data?.msg);
        getList();
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  const [modal, setModal] = useState({
    visible: false,
    id: '',
  });

  useEffect(() => {
    if(modal.id !== '') {
      getAssetCategoryDetail();
    } else {
      setData({
        categoryCode: '',
        categoryName: '',
        activeStatus: 'Y',
        sortOrder: 0,
      });
    }
  }, [modal.id]);

  async function getAssetCategoryDetail() {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/getAssetCategoryDetail.php", {
      ID: modal.id,
    }).then(function (response) {
      if (response?.data?.result) {
        const res = response.data.detail;
        setData({
          categoryCode: res.categoryCode || '',
          categoryName: res.categoryName || '',
          activeStatus: res.activeStatus || 'Y',
          sortOrder: res.sortOrder || '',
        });
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  async function setAssetCategory(id: any) {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/setAssetCategory.php", {
      ID: id,
      ...data
    }).then(function (response) {
      if (response?.data?.result) {
        alert(response?.data?.msg);
        setModal({ visible: false, id: '' }); // 모달 닫기
        getList();
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  return (
    <>
      <div className="contentBox administrator">
        <h3>Setting</h3>
        <div className="flexWrap">
          <div className="flexBox">
            <h4>
              Brand Assets 카테고리 관리
              <span className="content_count">{totalCount}</span>
            </h4>
            {/*<button className="addBtn" onClick={() => setModal({visible: true, id: ''})}>
              <i className="fa-solid fa-plus"></i>
              <span>Add New</span>
            </button>*/}
          </div>
          {/*<div className="search_box">
            <input type="text" ref={searchRef} placeholder="Search ..." defaultValue={keyword} onKeyDown={handleEnter}/>
            <button type="button" className="ic-button" onClick={handleSearch}>
              <img src="/assets/images/searchBox.png" alt="검색아이콘"/>
            </button>
          </div>*/}
        </div>

        <table className="table_hover">
          <thead>
          <tr>

            <th>
              <span className="sortWrap">
                  구분 코드
              </span>
            </th>
            <th>
              <span className="sortWrap">
                  카테고리명
              </span>
            </th>
            <th>
              <span className="sortWrap">
              </span>
            </th>
            <th>
              <span className="sortWrap">
              </span>
            </th>
            <th>
              <span className="sortWrap">
                  상태
              </span>
            </th>
            <th>
              <span className="sortWrap">
                  관리
              </span>
            </th>
          </tr>
          </thead>
          <tbody>
          {list?.map((list: any, index: number) => (
            <tr key={index}>

              <td>{list.categoryCode}</td>
              <td>{list.categoryName}</td>
              <td></td>
              <td></td>
              {/*<td>{list.sortOrder}</td>*/}
              <td>
                <span className="toggleSwitch">
                    <input type="checkbox" id={`member_statUs_${list.ID}`} className="toggleIpt" hidden checked={list?.activeStatus === 'Y' ? true : false} onChange={() => handleChange(list?.ID, list?.activeStatus)}/>
                    <label htmlFor={`member_statUs_${list.ID}`} className="toggleSwitch">
                        <span className="toggleButton"></span>
                    </label>
                </span>
              </td>
              <td>
                <button onClick={() => setModal({visible: true, id: list.ID})}></button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>

      {modal.visible && (
        <div className="modal">
          <div>
            <h2>{modal.id === '' ? '신규 카테고리 등록' : '카테고리 수정'}</h2>
            <div>
              <table>
                <tbody>
                <tr>
                  <td>
                    <label htmlFor="categoryCode">구분코드</label>
                    <input type="text" id="categoryCode" name="categoryCode" placeholder="예: IMAGE (제품 이미지용)" onChange={handleInputChange} value={data.categoryCode}/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="categoryName">카테고리명</label>
                    <input type="text" name="categoryName" id="categoryName" placeholder="예: Product Images" onChange={handleInputChange} value={data.categoryName}/>
                  </td>
                </tr>
                <tr>
                  <td className="radio">
                    <p style={{marginBottom: '10px'}}>노출 상태</p>
                    <label htmlFor="activeStatus1">사용 (노출)</label>
                    <input
                      type="radio"
                      value="Y"
                      name="activeStatus"
                      id="activeStatus1"
                      checked={data.activeStatus === 'Y'} // checked 처리
                      onChange={handleInputChange}
                    />
                    <label htmlFor="activeStatus2">미사용 (숨김)</label>
                    <input
                      type="radio"
                      value="N"
                      name="activeStatus"
                      id="activeStatus2"
                      checked={data.activeStatus === 'N'} // checked 처리
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="footer">
              <button className="close-button" onClick={() => setModal({visible: false, id: ''})}>취소</button>
              <button className="registration-button" onClick={() => setAssetCategory(modal.id || 0)}>{modal.id === '' ? '등록' : '수정'}하기</button>
            </div>
            <button className="close" onClick={() => setModal({visible: false, id: ''})}>X</button>
          </div>
        </div>
      )}
    </>
  )
}
